export default function LandingSectionHeader({ label, title, desc, className = "" }) {
  return (
    <header className={`landing-band__header ${className}`.trim()}>
      {label ? <span className="landing-band__label">{label}</span> : null}
      {title ? <h2 className="landing-band__title">{title}</h2> : null}
      {desc ? <p className="landing-band__desc">{desc}</p> : null}
    </header>
  );
}
